<template>
    <a class="ImageCard" :href="`#Id=${Id}`">
        <div class="top">
            <img :src="Img" />
            <div class="title">{{Title}}</div>
        </div>
        <div class="bottom">{{Info}}</div>
    </a>
</template>

<script>
export default {
    name: "ImageCard",
    components: {},
    props: {
        Id: {
            type: String
        },
        Img: {
            type: String,
            default: require("@/assets/activity/act01.jpg")
        },
        Title: {
            type: String,
            default: "標題"
        },
        Info: {
            type: String,
            default: "內文"
        }
    },
    data() {
        return {};
    },
    methods: {},
    computed: {},
    created() {},
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ImageCard {
    width: 100%;
    text-decoration: none;
}
.ImageCard .top {
    width: 100%;
    font-size: 0;
    border: 4px solid #a59b92;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    display: block;
    padding-bottom: 65%;
}
.ImageCard .top:hover img {
    transform: scale(1.1) translateY(-50%);
}
.ImageCard .top img {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-50%);
    transition: 1s;
}
.ImageCard .top .title {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: rgba(238, 139, 89, 0.9);
    font-size: 1rem;
    color: #fff;
    width: 100%;
    padding: 8px 5px;
}
.ImageCard .bottom {
    padding: 15px 10px;
    line-height: 1.5;
    color: #666;
}
@media screen and (max-width: 767px) {
    .ImageCard .bottom {
        padding: 15px 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/activity/imageCard.vue